// 获取访客列表
import { configFetch as fetch } from '@meiqia/utils';

export const getVisitorApi = data => {
  return fetch({
    url: '/visit/search',
    method: 'get',
    params: data
  });
};

// 邀请访客
export const inviteVisitorApi = params => {
  const { trackId, entId, type } = params;
  const data = {
    track_id: trackId
  };

  if (type) {
    // type用于在widget端判断调用原来的邀请还是智能引导
    data.type = type;
  }

  return fetch({
    url: `/visit/${trackId}/invite?ent_id=${entId}`,
    method: 'post',
    data
  });
};

// 获取访客轨迹
export const getVisitorPageApi = trackId => {
  return fetch({
    url: `/client/${trackId}/pages`,
    method: 'get'
  });
};

// 导出访客
export const exportVisitorApi = ({ begin, end }) => {
  return fetch({
    url: '/visit/jobs',
    method: 'POST',
    data: {
      end,
      begin
    }
  });
};
